export default __webpack_public_path__ + "locales/en/SendInviteDialog.json?hash=6f28b24b820f518b564ec28a5ce051ed";